import React from "react";

const CuteLoader = () => {
  return (
    <div className="cute-loader">
      <div className="spinner"></div>
      <p>잠시만 기다려주세요...</p>

      <style jsx>{`
        .cute-loader {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background-color: rgba(255, 255, 255, 1);
          z-index: 9999; /* 콘텐츠 위로 배치 */
        }
        .spinner {
          width: 50px;
          height: 50px;
          border: 5px solid #f3f3f3;
          border-top: 5px solid #3498db;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        p {
          margin-top: 20px;
          font-size: 14px;
          color: #555;
        }
      `}</style>
    </div>
  );
};

export default CuteLoader;
